// @core/api/endpoints/calendar/restore_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  RestoreEventRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Restore event
 * Restores a cancelled event back to confirmed status and notifies attendees.
 */
export async function RestoreEvent(
  event_id: string,
  data: RestoreEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/restore`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
